import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, Loader2, Mail, Lock } from "lucide-react";
import { formatApiError } from "../../lib/api";
import clienteApi, { CLI_TOKEN_KEY } from "../../lib/clienteApi";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { PasswordInput } from "../../components/PasswordInput";
import { Label } from "../../components/ui/label";
import { ClienteInstallButton } from "./ClienteInstallButton";
import CookieBanner from "../../components/CookieBanner";

export const ClienteBrand = () => (
  <div className="flex items-center gap-3">
    <div className="h-10 w-10 rounded-xl bg-amber-500 flex items-center justify-center"><Shield className="h-5 w-5 text-[#0a0d14]" strokeWidth={2.4} /></div>
    <div className="leading-tight">
      <div className="font-head font-extrabold text-lg">Patro<span className="text-amber-500">Gest</span>Pro</div>
      <div className="text-[10px] uppercase tracking-widest text-slate-500 font-mono">Area Riservata Cliente</div>
    </div>
  </div>
);

export default function ClienteLogin() {
  const nav = useNavigate();
  const [mode, setMode] = useState("password");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      if (mode === "password") {
        const { data } = await clienteApi.post("/cliente-auth/login", { email, password });
        localStorage.setItem(CLI_TOKEN_KEY, data.token);
        nav("/cliente", { replace: true });
      } else {
        await clienteApi.post("/cliente-auth/magic-link/request", { email, app_url: window.location.origin });
        setSent(true);
      }
    } catch (e2) { setErr(formatApiError(e2.response?.data?.detail)); } finally { setBusy(false); }
  };

  const tab = (m, l) => (
    <button type="button" onClick={() => { setMode(m); setErr(""); setSent(false); }} data-testid={`cliente-mode-${m}`}
      className={`flex-1 py-2 text-sm font-semibold transition-colors ${mode === m ? "bg-amber-500 text-[#0a0d14]" : "bg-slate-800 text-white hover:bg-slate-700"}`}>{l}</button>
  );

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 pgp-grid-bg" data-testid="cliente-login-page">
      <CookieBanner />
      <div className="w-full max-w-sm pgp-fade-up">
        <div className="mb-8"><ClienteBrand /></div>
        <h1 className="font-head text-2xl font-bold text-slate-50">Accedi alla tua Area Riservata</h1>
        <p className="text-sm text-slate-400 mt-1 mb-5">Segui la tua pratica, i messaggi e i documenti.</p>
        <div className="flex rounded-lg border border-slate-700 overflow-hidden mb-5">{tab("password", "Password")}{tab("magic", "Link via email")}</div>
        {err && <p className="text-sm text-red-500 mb-3" data-testid="cliente-login-error">{err}</p>}
        {sent ? (
          <p className="text-sm text-slate-300" data-testid="cliente-magic-sent">Se l'email è associata a un account, riceverai un link di accesso valido 24 ore.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="cliente-login-form">
            <div><Label className="text-slate-300 text-sm">Email</Label>
              <div className="relative mt-1.5"><Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
                <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="cliente-login-email" className="pl-10 h-11" /></div></div>
            {mode === "password" && (
              <div><Label className="text-slate-300 text-sm">Password</Label>
                <div className="relative mt-1.5"><Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
                  <PasswordInput required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="cliente-login-password" className="pl-10 h-11" /></div></div>
            )}
            <Button type="submit" disabled={busy} data-testid="cliente-login-submit" className="w-full h-11 bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : mode === "password" ? "Accedi" : "Inviami il link di accesso"}
            </Button>
          </form>
        )}
        <ClienteInstallButton />
      </div>
    </div>
  );
}
